export default __webpack_public_path__ + "static/media/plausible-dark.3762ab13.png";